// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const OperationscatalogOperationType = {
  OperationTypeDatabaseOperation: 'database-operation',
  OperationTypeServerOperation: 'server-operation',
  OperationTypeNeo4jClusterOperation: 'neo4j-cluster-operation',
} as const;
export type OperationscatalogOperationType =
  (typeof OperationscatalogOperationType)[keyof typeof OperationscatalogOperationType];

export function instanceOfOperationscatalogOperationType(value: any): boolean {
  for (const key in OperationscatalogOperationType) {
    if (
      Object.prototype.hasOwnProperty.call(OperationscatalogOperationType, key)
    ) {
      if (
        OperationscatalogOperationType[
          key as keyof typeof OperationscatalogOperationType
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function OperationscatalogOperationTypeFromJSON(
  json: any,
): OperationscatalogOperationType {
  return OperationscatalogOperationTypeFromJSONTyped(json, false);
}

export function OperationscatalogOperationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationscatalogOperationType {
  return json as OperationscatalogOperationType;
}

export function OperationscatalogOperationTypeToJSON(
  value?: OperationscatalogOperationType | null,
): any {
  return value as any;
}

export function OperationscatalogOperationTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): OperationscatalogOperationType {
  return value as OperationscatalogOperationType;
}
